module.exports = __webpack_public_path__ + "img/logo.28b4fd4c.svg";